import { InfoIcon } from 'components/Icons/Info';
import { useGlassesStore } from 'zus/glassesStore';

export default function WarningMessageComponent() { 
    const category = useGlassesStore((state) => state.category) 
    const frameColorDisplayZ = useGlassesStore((state) => state.frame_color_display);
    const frameColorZ = useGlassesStore((state) => state.frame_color);
    const lens_thickness_selected = useGlassesStore((state) => state.lens_thickness_selected);
    const productPrice = (lens_thickness_selected ? ' - $' + lens_thickness_selected.price : '');

    if((frameColorZ == 'recycled-money')) return (
        <div>{
            <div className="bg-[#FFF4CC] px-5 py-2 flex items-center text-sm rounded text-brand-grey300 mt-6 ">
                <span className="mr-3"><InfoIcon /></span> <span>Each {frameColorDisplayZ} frame is unique and can{`’`}t share or swap lenses with other Dresden frames.</span>
            </div>}  
        </div>
    )

    return (<></>)
    
}